:root {
  color-scheme: dark;
  font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  background: #080b0a;
  --tg-content-safe-area-inset-top: 0px;
  --tg-content-safe-area-inset-right: 0px;
  --tg-content-safe-area-inset-bottom: 0px;
  --tg-content-safe-area-inset-left: 0px;
}

* {
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}

html,
body,
#app {
  width: 100%;
  height: 100%;
  min-height: 100%;
  margin: 0;
  overflow: hidden;
  overscroll-behavior: none;
  background:
    radial-gradient(circle at 50% 20%, rgba(87, 55, 38, 0.16), transparent 34%),
    #080b0a;
}

body {
  touch-action: none;
  user-select: none;
}

#app {
  display: grid;
  place-items: center;
  padding:
    var(--tg-content-safe-area-inset-top)
    var(--tg-content-safe-area-inset-right)
    var(--tg-content-safe-area-inset-bottom)
    var(--tg-content-safe-area-inset-left);
}

#game {
  width: 100%;
  height: 100%;
  display: grid;
  place-items: center;
}

#game canvas {
  display: block;
  max-width: 100%;
  max-height: 100%;
  box-shadow: 0 0 52px rgba(0, 0, 0, 0.7);
}

#rotate-hint {
  display: none;
  position: fixed;
  inset: auto 16px 12px;
  z-index: 10;
  margin: 0;
  padding: 8px 12px;
  border: 1px solid rgba(202, 177, 128, 0.24);
  border-radius: 10px;
  color: #d8c9a8;
  background: rgba(11, 14, 13, 0.86);
  text-align: center;
  font-size: 12px;
}

@media (orientation: landscape) and (max-height: 600px) {
  #rotate-hint {
    display: block;
  }
}
